import React from "react";

const AksaraCharGrid = ({
  chars,
  getBoxStyle,
  getBarStyle,
  onCharClick,
  emptyAtStart = 0,
  emptyAtEnd = 0,
  darkMode = false,
}) => {
  const emptyBox = (
    <div
      className={`flex flex-col items-center justify-between rounded-2xl border-2 p-3 min-h-[90px] min-w-[70px] opacity-100 ${
        darkMode
          ? "bg-gray-700 border-gray-600 text-gray-600"
          : "bg-gray-200 border-gray-400 text-gray-400"
      }`}
      aria-hidden="true"
    ></div>
  );
  const emptiesStart = Array.from({ length: emptyAtStart }, (_, i) =>
    React.cloneElement(emptyBox, { key: `empty-start-${i}` })
  );
  const emptiesEnd = Array.from({ length: emptyAtEnd }, (_, i) =>
    React.cloneElement(emptyBox, { key: `empty-end-${i}` })
  );

  return (
    <div className="grid grid-cols-4 md:grid-cols-4 lg:grid-cols-5 gap-4 mb-10">
      {emptiesStart}
      {chars.map((c, idx) => (
        <button
          key={c.char + idx}
          className={`flex flex-col items-center justify-between rounded-2xl border-2 p-3 min-h-[90px] min-w-[70px] duration-200 transform hover:-translate-y-0.5 transition-all outline-none shadow-sm group cursor-pointer 
            ${getBoxStyle(c.status, darkMode)}
          `}
          onClick={() => onCharClick(c, idx)}
          aria-label={c.latin}
          tabIndex={0}
        >
          <span
            className={`text-2xl md:text-3xl font-base mb-1 ${
              darkMode ? "text-gray-100" : "text-gray-800"
            }`}
            style={{ fontFamily: "Noto Sans Batak" }}
          >
            {Array.isArray(c.chars) ? c.chars[0] : c.char}
          </span>
          <span
            className={`text-xs md:text-sm font-medium mb-2 opacity-80 ${
              darkMode ? "text-gray-300" : "text-gray-700"
            }`}
          >
            {c.latin}
          </span>
          <div
            className={`w-full h-2 rounded-full overflow-hidden mt-auto ${
              darkMode ? "bg-gray-700" : "bg-gray-300"
            }`}
          >
            <div
              className={`${getBarStyle(
                c.status, darkMode
              )} h-2 rounded-full transition-all`}
              style={{
                width: `${Math.round(
                  ((c.currentLesson ?? 0) / (c.totalLesson ?? 1)) * 100
                )}%`,
              }}
            />
          </div>
        </button>
      ))}
      {emptiesEnd}
    </div>
  );
};

export default AksaraCharGrid;
